import { render, staticRenderFns } from "./bi-form-view.vue?vue&type=template&id=e5a2105c&scoped=true&"
import script from "./bi-form-view.vue?vue&type=script&lang=ts&"
export * from "./bi-form-view.vue?vue&type=script&lang=ts&"
import style0 from "./bi-form-view.vue?vue&type=style&index=0&id=e5a2105c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a2105c",
  null
  
)

export default component.exports